import React, { useState } from 'react';
import AddQuestion from './AddQuestion';
import ViewQuestions from './ViewQuestions';
import Button from '../../components/Button';

const QuestionManagement: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'add' | 'view'>('add');
  const [refreshKey, setRefreshKey] = useState(0);

  const handleQuestionAdded = () => {
    setRefreshKey(prev => prev + 1);
  };

  const handleQuestionDeleted = () => {
    setRefreshKey(prev => prev + 1);
  };

  return (
    <div className="w-full px-4 sm:px-6 lg:px-0">
      <div className="flex flex-wrap justify-center gap-4 mb-6">
        <Button
          variant={activeTab === 'add' ? 'primary' : 'secondary'}
          onClick={() => setActiveTab('add')}
          className={`flex items-center gap-2 px-4 py-2 ${
            activeTab === 'add'
              ? 'bg-[#4B7BFF] text-white hover:bg-[#3D63CC] border border-[#3D63CC]'
              : 'bg-[#2D3748] text-[#CBD5E0] hover:bg-[#4A5568] border border-[#4A5568]'
          }`}
        >
          إضافة سؤال
        </Button>
        <Button
          variant={activeTab === 'view' ? 'primary' : 'secondary'}
          onClick={() => setActiveTab('view')}
          className={`flex items-center gap-2 px-4 py-2 ${
            activeTab === 'view'
              ? 'bg-[#4B7BFF] text-white hover:bg-[#3D63CC] border border-[#3D63CC]'
              : 'bg-[#2D3748] text-[#CBD5E0] hover:bg-[#4A5568] border border-[#4A5568]'
          }`}
        >
          عرض وتصفية
        </Button>
      </div>

      {activeTab === 'add' ? (
        <AddQuestion onQuestionAdded={handleQuestionAdded} />
      ) : (
        <ViewQuestions key={refreshKey} onQuestionDeleted={handleQuestionDeleted} />
      )}
    </div>
  );
};

export default QuestionManagement;
